
import { Editor } from '../mind';

export default Editor;